module.exports = __webpack_public_path__ + "static/grafika3@2x-c52e951e9543528bb5b201a8be7d33c0.png";